import controller from './detail-zone.controller';
import template from './detail-zone.view.html';

let DetailZoneComponent = {
  template,
  controller,
  bindings : {
    shCtrl : '<'
  }
};

export default DetailZoneComponent;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/pay-zone/detail-zone/detail-zone.component.js
 **/